module.exports = __webpack_public_path__ + "img/pic12.a3e8898e.png";